import { notificationTest, notifications } from "../../routes/api/paths";
import { handleResponse, requestOptions } from "../HandlerService";

export const ListNotificationService = async (data) => {
  const { token, body } = data;
  const options = requestOptions('POST', body, token);
  return fetch(notifications, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const NotificationService = async (data) => {
  const { token, notification } = data;
  const options = requestOptions('GET', {}, token);
  return fetch(`${notifications}/${notification}`, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const NotificationTestService = async (data) => {
  const { token, notification } = data;
  const options = requestOptions('GET', {}, token);
  return fetch(`${notificationTest}/${notification}`, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}